import React, { useState, useRef } from "react";

//#region Material Components
import { withStyles } from "@material-ui/styles";
import MuiDialog from "@material-ui/core/Dialog";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";
import Divider from "@material-ui/core/Divider";
//#endregion

//#region Internal
import ApproveButton from "./ApproveButton";

import { Primary } from "../../assets/Colors";
import { getReportsDetails, getImageUrlR, cropPage, getAchievementVideoDetail, getLectureSectionDetail,removeContent } from "../../api/FeedBacks";
import { useEffect } from "react";
import { Modal, CircularProgress} from "@material-ui/core";
import {
  deleteQuestion,
  deleteVideo,
  deleteQuestionAdmin,
  deleteVideoAdmin,
  getEditorialSystemId,
} from "../../api/BookSectionCrop";
import { toast } from "react-toastify";
import EditorialSystemId from "../../enums/EditorialSystemId";
import ReportContentType from "../../enums/ReportContentType";

//#endregion
const Dialog = withStyles({
  paperWidthSm: {
    maxWidth: 920,
    minWidth: 300,
    minHeight: 220,
  },
})(MuiDialog);
const DialogContent = withStyles({
  root: {
    paddingTop: 0,
    display: "flex",
    flexDirection: "column",
    width: "50%",
  },
})(MuiDialogContent);

const DialogTitle = withStyles({
  root: {
    marginLeft: 20,
  },
})(MuiDialogTitle);

let option = "";
function ReportDialog(props) {
  const [details, setDetails] = useState([]);
  const [cropIdDetails, setCropIdDetails] = useState([]);
  const [showConfirm, setShowConfirm] = useState(false);
  const [imageUrl, setImageUrl] = useState({
    mainImage: null,
    imageParts: [],
    RowStatus: false,
  });
  const [editorialSystemIdInfo, setEditorialSystemIdInfo] = useState(null);
  const [displayDeleteQuestionModal, setDisplayDeleteQuestionModal] =
    useState(false);
  const [displayDeleteVideoModal, setDisplayDeleteVideoModal] = useState(false);
  const [achievementVideoDetail, setAchievementVideoDetail] = useState(null);
  const [lectureSectionDetail, setLectureSectionDetail] = useState(null);
  const [selectedReportId, setSelectedReportId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const videoRef = useRef(null);
  const pendingSeekRef = useRef(null);
  const [videoTab, setVideoTab] = useState("mp4");
  const [videoError, setVideoError] = useState(false);
  const row = props.editRow.content;
  const cropId = props.selectedCropId;
  const correct = row
    ? row[6].content
    : cropIdDetails
    ? cropIdDetails.AnswerOption
    : "";
  const pJWT = sessionStorage.getItem("jwtP");
  const getDetails = async () => {
    let res = await getReportsDetails(row[3].content, props.user.Token);
    if (res.status === 200) {
      setDetails(res.data);
    }
  };
  const getDetailsNEW = async () => {
    let res = await getReportsDetails(cropId, props.user.Token);
    if (res.status === 200) {
      setDetails(res.data);
    }
  };
  const deleteVideoReq = async (data) => {
    const resDev = await deleteVideo(data, props.user.Token);
    const resProd = await deleteVideoAdmin(data, pJWT);
    if (resDev.status == 200) {
      if (resDev) {
        toast.success("Video Deleted Successfully on Dev");
      } else {
        toast.error("Video could not found on Dev");
      }
    } else toast.error("Bir hata oluştu lütfen tekrar deneyiniz");
    if (resProd.status == 200) {
      if (resProd) {
        toast.success("Video Deleted Successfully on Prod");
      } else {
        toast.error("Video could not found on Prod");
      }
    } else if (resProd.status == 401) {
      toast.error("Lütfen Tekrar Giriş Yapınız");
    } else toast.error("Bir hata oluştu lütfen tekrar deneyiniz");
  };
  const deleteQuestionReq = async (data) => {
    const resDev = await deleteQuestion(data, props.user.Token);
    const resProd = await deleteQuestionAdmin(data, pJWT);
    if (resDev.status == 200) {
      if (resDev) {
        toast.success("Question Deleted Successfully on Dev");
      } else {
        toast.error("Question could not found on Dev");
      }
    } else toast.error("Bir hata oluştu lütfen tekrar deneyiniz");
    if (resProd.status == 200) {
      if (resProd) {
        toast.success("Question Deleted Successfully on Prod");
      } else {
        toast.error("Question could not found on Prod");
      }
    } else if (resProd.status == 401) {
      toast.error("Lütfen Tekrar Giriş Yapınız");
    } else toast.error("Bir hata oluştu lütfen tekrar deneyiniz");
  };
  const getCropPage = async () => {
    let res = await cropPage(Number(cropId), props.user.Token);
    if (res.status === 200) {
      console.log("res.data", res.data);
      setCropIdDetails(res.data);
    } else {
      props.modalControl(false);
    }
  };
  useEffect(() => {
    if (cropId) {
      setCropIdDetails([]);
      setDetails([]);
      getCropPage();
      getDetailsNEW();
    }
  }, [cropId]);
  const getImageUrl = async (share) => {
    const param = {
      BookSectionId: row[4].content,
      QuestionNumber: row[5].content,
    };
    let res = await getImageUrlR(param, props.user.Token);
    if (res.status === 200) {
      let url = "https://product.pakodemy.com/share/index.htm?q=";
      if (share) {
        let q = res.data.ImageUrl.substring(
          res.data.ImageUrl.indexOf("crops") + 6
        );
        const part = res.data.ImagePartUrls[0];
        if (part) {
          q += `__${part.substring(part.indexOf("crops") + 6)}`;
        }
        url = url + q;
      } else {
        url = res.data.ImageUrl;
      }
      const newWindow = window.open(url, "_blank", "noopener,noreferrer");
      if (newWindow) newWindow.opener = null;
    }
  };
  const getImageUrlNEW = async (share) => {
    const param = {
      BookSectionId: cropIdDetails.BookSectionId,
      QuestionNumber: cropIdDetails.QuestionNumber,
    };
    let res = await getImageUrlR(param, props.user.Token);
    if (res.status === 200) {
      let url = "https://product.pakodemy.com/share/index.htm?q=";
      if (share) {
        let q = res.data.ImageUrl.substring(
          res.data.ImageUrl.indexOf("crops") + 6
        );
        const part = res.data.ImagePartUrls[0];
        if (part) {
          q += `__${part.substring(part.indexOf("crops") + 6)}`;
        }
        url = url + q;
      } else {
        url = res.data.ImageUrl;
      }
      const newWindow = window.open(url, "_blank", "noopener,noreferrer");
      if (newWindow) newWindow.opener = null;
    }
  };

  // const showImageOnModal = async() => {
  //   if (cropId) {
  //     const param = {
  //       BookSectionId: cropIdDetails.BookSectionId,
  //       QuestionNumber: cropIdDetails.QuestionNumber,
  //     };
  //     let res = await getImageUrlR(param, props.user.Token);
  //     if (res.status === 200) {
  //       console.log("cropIdres.data.ImageUrl",res.data.ImageUrl);
  //     return res.data.ImageUrl
  //     }
  //   } else if (row) {
  //     const param = {
  //       BookSectionId: row[4].content,
  //       QuestionNumber: row[5].content,
  //     };
  //     let res = await getImageUrlR(param, props.user.Token);
  //     if (res.status === 200) {
  //       console.log("rowres.data.ImageUrl",res.data.ImageUrl);
  //       return res.data.ImageUrl
  //       }
  //   } else {
  //     return;
  //   }
  // }
  const fetchImageUrl = async () => {
    let param;
    if (row) {
      param = {
        BookSectionId: row[4].content,
        QuestionNumber: row[5].content,
      };
    } else if (cropId && cropIdDetails) {
      param = {
        BookSectionId: cropIdDetails.BookSectionId,
        QuestionNumber: cropIdDetails.QuestionNumber,
      };
    } else {
      return;
    }

    try {
      const res = await getImageUrlR(param, props.user.Token);
      if (res.status === 200) {
        console.log("Fetched Image URL:", res.data.ImageUrl);
        const { ImageUrl, ImagePartUrls, RowStatus } = res.data;
        setImageUrl({
          mainImage: ImageUrl,
          imageParts: ImagePartUrls,
          RowStatus: RowStatus,
        });
      }
    } catch (error) {
      console.error("Error fetching image URL:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const fetchEditorialSystemId = async () => {
    let param;
    if (row) {
      param = {
        BookSectionId: row[4].content,
      };
    } else if (cropId && cropIdDetails) {
      param = {
        BookSectionId: cropIdDetails.BookSectionId,
      };
    } else {
      return;
    }

    try {
      const res = await getEditorialSystemId(
        param.BookSectionId,
        props.user.Token
      );
      if (res.status === 200) {
        console.log("Fetched Image URL:", res.data.ImageUrl);
        setEditorialSystemIdInfo(res.data.ResponseData);
      }
    } catch (error) {
      console.error("Error fetching image URL:", error);
    }
  };
  useEffect(() => {
    if (!props.isOpen) return;
    setImageUrl({ mainImage: null, imageParts: [], RowStatus: false });
    setIsLoading(true);
    fetchImageUrl();
    fetchEditorialSystemId();
  }, [props.isOpen, cropId, cropIdDetails, row, props.user.Token]);

  useEffect(() => {
    if (!props.isOpen) {
      setAchievementVideoDetail(null);
      setLectureSectionDetail(null);
      setSelectedReportId(null);
      return;
    }
    setAchievementVideoDetail(null);
    setLectureSectionDetail(null);
    setSelectedReportId(null);
    if (props.reportContentType === 3 && row) {
      getAchievementVideoDetail(row[3].content, props.user.Token).then((res) => {
        if (res?.status === 200) {
          setAchievementVideoDetail(res.data.ResponseData);
        }
      });
    }
    if (props.reportContentType === 4 && row) {
      getLectureSectionDetail(row[3].content, props.user.Token).then((res) => {
        if (res?.status === 200) {
          setLectureSectionDetail(res.data.ResponseData);
        }
      });
    }
  }, [props.isOpen, row]);

  const seekVideo = (seconds) => {
    if (videoRef.current) {
      videoRef.current.currentTime = Math.max(0, seconds - 5);
      videoRef.current.play();
    }
  };

  // Switch between the MP4 and HLS sources while keeping the current
  // position/play-state, since both feeds share the same single <video>.
  const switchVideoTab = (tab) => {
    if (tab === videoTab || !achievementVideoDetail) return;
    if (videoRef.current) {
      pendingSeekRef.current = {
        time: videoRef.current.currentTime,
        playing: !videoRef.current.paused,
      };
    }
    setVideoError(false);
    setVideoTab(tab);
  };

  // Reset to the MP4 tab whenever a different video is loaded into the dialog.
  useEffect(() => {
    setVideoTab("mp4");
    setVideoError(false);
    pendingSeekRef.current = null;
  }, [achievementVideoDetail?.AchievementVideoId]);

  const deleteAchievementVideoReq = async () => {
    const res = await removeContent(achievementVideoDetail.AchievementVideoId,ReportContentType.AchievementVideo, props.user.Token);
    if (res.status === 200) {
      toast.success("Video Deleted Successfully");
    } else {
      toast.error("Bir hata oluştu lütfen tekrar deneyiniz");
    }
    setDisplayDeleteVideoModal(false);
  };

  const deleteLectureSectionReq = async () => {
    const res = await removeContent(lectureSectionDetail.LectureId,ReportContentType.LectureSection ,props.user.Token);
    if (res.status === 200) {
      toast.success("Lecture Section Deleted Successfully");
    } else {
      toast.error("Bir hata oluştu lütfen tekrar deneyiniz");
    }
    setDisplayDeleteVideoModal(false);
  };

  useEffect(() => {
    if (row) {
      setDetails([]);
      getDetails();
    }
  }, [row]);

  const chAnswer = (opt) => {
    return correct === opt
      ? "*| " + opt + " |*"
      : opt === option
      ? opt + "-"
      : opt;
  };
  const onClickAnswerChange = (r, opt) => {
    option = opt;
    setShowConfirm(true);
  };
  const openVideo = () => {
    const url = row[7].content;
    const newWindow = window.open(url, "_blank", "noopener,noreferrer");
    if (newWindow) newWindow.opener = null;
  };
  const openVideoNEW = () => {
    const url = cropIdDetails.AnswerVideoPath;
    const newWindow = window.open(url, "_blank", "noopener,noreferrer");
    if (newWindow) newWindow.opener = null;
  };
  return (
    <Dialog
      id={props.id}
      open={props.isOpen}
      onClose={() => {
        props.onClose();
        setImageUrl({
          mainImage: null,
          imageParts: [],
        });
      }}
    >
      {displayDeleteQuestionModal && (
        <Dialog
          open={displayDeleteQuestionModal}
          onClose={() => setDisplayDeleteQuestionModal(false)}
        >
          <div style={styles.deleteModalStyle}>
            <p>Artık bu soruyu kullanıcılar göremeyecek.</p>
            <p>Silmek istediğine emin misin?</p>
            <div style={styles.deletebuttonStyle}>
              <button
                onClick={() => {
                  deleteQuestionReq(cropId || row[4].content);
                  setDisplayDeleteQuestionModal(false);
                }}
                style={styles.deleteConfirm}
              >
                Sil
              </button>
              <button
                onClick={() => setDisplayDeleteQuestionModal(false)}
                style={styles.deleteConfirmClose}
              >
                Vazgeç
              </button>
            </div>
          </div>
        </Dialog>
      )}
      {displayDeleteVideoModal && (
        <Dialog
          open={displayDeleteVideoModal}
          onClose={() => setDisplayDeleteVideoModal(false)}
        >
          <div style={styles.deleteModalStyle}>
            <p>Artık bu sorunun videosunu kullanıcılar göremeyecek.</p>
            <p>Silmek istediğine emin misin?</p>
            <div style={styles.deletebuttonStyle}>
              <button
                onClick={() => {
                  if (props.reportContentType === 3) {
                    deleteAchievementVideoReq();
                  } else if (props.reportContentType === 4) {
                    deleteLectureSectionReq();
                  } else {
                    deleteVideoReq(cropId || row[4].content);
                    setDisplayDeleteVideoModal(false);
                  }
                }}
                style={styles.deleteConfirm}
              >
                Sil
              </button>
              <button
                onClick={() => setDisplayDeleteVideoModal(false)}
                style={styles.deleteConfirmClose}
              >
                Vazgeç
              </button>
            </div>
          </div>
        </Dialog>
      )}
      <div style={styles.generalContainer}>
        <div
          style={{
            backgroundColor: Primary.Background,
          }}
        >
          <DialogTitle>İşlemler</DialogTitle>
          <div>
            {props.reportContentType === 3 ? (
              achievementVideoDetail ? (
                <>
                  <div style={styles.videoTabBar}>
                    <button
                      type="button"
                      onClick={() => switchVideoTab("mp4")}
                      style={
                        videoTab === "mp4"
                          ? styles.videoTabActive
                          : styles.videoTab
                      }
                    >
                      MP4
                    </button>
                    <button
                      type="button"
                      disabled={!achievementVideoDetail.VideoHlsUrl}
                      onClick={() => switchVideoTab("hls")}
                      title={
                        achievementVideoDetail.VideoHlsUrl
                          ? "HLS"
                          : "Bu video için HLS mevcut değil"
                      }
                      style={
                        !achievementVideoDetail.VideoHlsUrl
                          ? styles.videoTabDisabled
                          : videoTab === "hls"
                          ? styles.videoTabActive
                          : styles.videoTab
                      }
                    >
                      HLS
                    </button>
                  </div>
                  <video
                    key={videoTab}
                    ref={videoRef}
                    src={
                      videoTab === "hls" && achievementVideoDetail.VideoHlsUrl
                        ? achievementVideoDetail.VideoHlsUrl
                        : achievementVideoDetail.VideoUrl
                    }
                    controls
                    onError={() => setVideoError(true)}
                    onLoadedMetadata={() => {
                      setVideoError(false);
                      const pending = pendingSeekRef.current;
                      if (pending && videoRef.current) {
                        videoRef.current.currentTime = pending.time;
                        if (pending.playing) {
                          videoRef.current.play().catch(() => {});
                        }
                        pendingSeekRef.current = null;
                      }
                    }}
                    style={{ maxWidth: "100%", maxHeight: "400px" }}
                  />
                  {videoTab === "hls" && videoError && (
                    <div style={{ color: "red", fontSize: 12, padding: "4px 8px" }}>
                      HLS bu tarayıcıda oynatılamadı. (Lütfen Yazılım ekibine bildiriniz.)
                    </div>
                  )}
                </>
              ) : (
                <div style={{ display: "flex", justifyContent: "center", padding: 20 }}>
                  <CircularProgress />
                </div>
              )
            ) : props.reportContentType === 4 ? (
              lectureSectionDetail ? (
                <img
                  src={lectureSectionDetail.ImageUrl}
                  alt="Lecture Section"
                  style={{ maxWidth: "100%", maxHeight: "400px", objectFit: "contain" }}
                />
              ) : (
                <div style={{ display: "flex", justifyContent: "center", padding: 20 }}>
                  <CircularProgress />
                </div>

              )
            ) : (
              <>
                {isLoading ? (
                  <div style={{ display: "flex", justifyContent: "center", padding: 20 }}>
                    <CircularProgress />
                  </div>
                ) : imageUrl.mainImage ? (
                  <img
                    style={{
                      maxWidth: "100%",
                      maxHeight: "300px",
                      objectFit: "contain",
                    }}
                    src={imageUrl.mainImage}
                    alt="Dynamic"
                  />
                ) : null}
                {imageUrl.imageParts.length > 0 && (
                  <div>
                    {imageUrl.imageParts.map((partUrl, index) => (
                      <img
                        key={index}
                        src={partUrl}
                        alt={`Part ${index + 1}`}
                        style={{
                          maxWidth: "100%",
                          maxHeight: "300px",
                          objectFit: "contain",
                        }}
                      />
                    ))}
                  </div>
                )}
              </>
            )}
          </div>
          <Divider />
        </div>

        <DialogContent>
          {props.reportContentType === 3 ? (
            <>
              <ApproveButton
                key="btn1"
                onClick={() => props.markAsDone(row)}
                text="Mark As Done"
              />
              {achievementVideoDetail?.RowStatus && (
                <div style={{ display: "flex", justifyContent: "flex-end", margin: "10px" }}>
                  <button
                    onClick={() => setDisplayDeleteVideoModal(true)}
                    style={{ border: "1px solid red", color: "red" }}
                  >
                    Delete Video
                  </button>
                </div>
              )}
              <div style={{ display: "flex", borderBottom: 1 }}>
                <p style={styles.id}>User Id</p>
                <p style={styles.desc1}>Description 1</p>
                <p style={styles.desc1}>Description 2</p>
                <p style={styles.desc1}>Time</p>
              </div>
              <Divider />
              <div style={{ scrollBehavior: "smooth" }}>
                {achievementVideoDetail?.Reports?.map((report) => (
                  <React.Fragment key={report.ReportId}>
                    <div
                       style={{
                        display: "flex",
                        cursor: "pointer",
                        padding: "6px 8px",
                        borderRadius: 6,
                        backgroundColor: selectedReportId === report.ReportId ? "#e8f0fe" : "transparent",
                        border: selectedReportId === report.ReportId ? "1.5px solid #4285f4" : "1.5px solid transparent",
                        transition: "background-color 0.2s, border 0.2s",
                      }}
                      onClick={() => {
                        setSelectedReportId(report.ReportId);
                        seekVideo(report.ReportSecond);
                      }}
                    >
                      <p style={styles.id}>{report.UserId}</p>
                      <p style={styles.desc1}>{report.Description1}</p>
                      <p style={styles.desc1}>{report.Description2}</p>
                      <p style={styles.desc1}>{report.ReportTime}</p>
                    </div>
                    <Divider />
                  </React.Fragment>
                ))}
              </div>
            </>
          ) : props.reportContentType === 4 ? (
            <>
              <ApproveButton
                key="btn1"
                onClick={() => props.markAsDone(row)}
                text="Mark As Done"
              />
              {lectureSectionDetail?.RowStatus && (
                <div style={{ display: "flex", justifyContent: "flex-end", margin: "10px" }}>
                  <button
                    onClick={() => setDisplayDeleteVideoModal(true)}
                    style={{ border: "1px solid red", color: "red" }}
                  >
                    Delete Lecture Section
                  </button>
                </div>
              )}
              <div style={{ display: "flex", borderBottom: 1 }}>
                <p style={styles.id}>User Id</p>
                <p style={styles.desc1}>Description 1</p>
                <p style={styles.desc1}>Description 2</p>
                <p style={styles.desc1}>Created Date</p>
              </div>
              <Divider />
              <div style={{ scrollBehavior: "smooth" }}>
                {lectureSectionDetail?.Reports?.map((report) => (
                  <React.Fragment key={report.ReportId}>
                    <div style={{ display: "flex", padding: "6px 0" }}>
                      <p style={styles.id}>{report.UserId}</p>
                      <p style={styles.desc1}>{report.Description1}</p>
                      <p style={styles.desc1}>{report.Description2}</p>
                      <p style={styles.desc1}>{new Date(report.CreatedDate).toLocaleDateString()}</p>
                    </div>
                    <Divider />
                  </React.Fragment>
                ))}
              </div>
            </>
          ) : (
            <>
              <div style={styles.container}>
                <Button
                  onClick={() => onClickAnswerChange(row, "A")}
                  style={styles.AnswerOpt}
                >
                  {chAnswer("A")}
                </Button>
                <Button
                  onClick={() => onClickAnswerChange(row, "B")}
                  style={styles.AnswerOpt}
                >
                  {chAnswer("B")}
                </Button>
                <Button
                  onClick={() => onClickAnswerChange(row, "C")}
                  style={styles.AnswerOpt}
                >
                  {chAnswer("C")}
                </Button>
                <Button
                  onClick={() => onClickAnswerChange(row, "D")}
                  style={styles.AnswerOpt}
                >
                  {chAnswer("D")}
                </Button>
                <Button
                  onClick={() => onClickAnswerChange(row, "E")}
                  style={styles.AnswerOpt}
                >
                  {chAnswer("E")}
                </Button>
              </div>
              {showConfirm ? (
                <div
                  style={{
                    width: 400,
                    borderRadius: 8,
                    margin: 5,
                    background: "#bcbcbc",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: 10,
                  }}
                >
                  <p style={{ textAlign: "center" }}>
                    Cevap Değiştirmeyi Onaylıyormusun
                  </p>
                  <div
                    style={{
                      alignItems: "center",
                      justifyContent: "center",
                      flexDirection: "row",
                      width: "100%",
                    }}
                  >
                    <ApproveButton
                      text="Iptal"
                      style={{
                        width: 120,
                        marginLeft: 10,
                        backgroundColor: Primary.LinkText,
                      }}
                      onClick={() => {
                        option = "";
                        setShowConfirm(false);
                      }}
                    />
                    <ApproveButton
                      text="Değiştir"
                      style={{ width: 120, marginLeft: 10 }}
                      onClick={() => {
                        if (cropId) {
                          props.onClickAnswerChangeNEW(cropIdDetails, option);
                        } else if (row) {
                          props.onClickAnswerChange(row, option);
                        } else return;
                      }}
                    />
                  </div>
                </div>
              ) : (
                <></>
              )}
              <ApproveButton
                key="btn1"
                onClick={() => {
                  if (cropId) {
                    props.markAsDoneNEW(cropIdDetails);
                  } else if (row) {
                    props.markAsDone(row);
                  } else return;
                }}
                text="Mark As Done"
              />
              {editorialSystemIdInfo === EditorialSystemId.CropPage && (
                <ApproveButton
                  key="btn3"
                  onClick={() => {
                    if (cropId) {
                      props.rowClickNEW(cropIdDetails);
                    } else if (row) {
                      props.rowClick(row);
                    } else return;
                  }}
                  text="Go To Crop Page"
                />
              )}
              <ApproveButton
                key="btn4"
                onClick={() => {
                  if (cropId) {
                    getImageUrlNEW(true);
                  } else if (row) {
                    getImageUrl(true);
                  } else {
                    return;
                  }
                }}
                text="Share Link"
              />
              {row && row[7].content ? (
                <ApproveButton key="btn5" onClick={openVideo} text="Open Video" />
              ) : cropIdDetails && cropIdDetails.AnswerVideoPath ? (
                <ApproveButton key="btn5" onClick={openVideoNEW} text="Open Video" />
              ) : (
                false
              )}
              {imageUrl.RowStatus ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    margin: "10px",
                  }}
                >
                  {(row && row[7].content) ||
                  (cropIdDetails && cropIdDetails.AnswerVideoPath) ? (
                    <button
                      onClick={() => setDisplayDeleteVideoModal(true)}
                      style={{ border: "1px solid red", color: "red" }}
                    >
                      Delete video
                    </button>
                  ) : (
                    false
                  )}
                  <button
                    onClick={() => setDisplayDeleteQuestionModal(true)}
                    style={{
                      marginLeft: "10px",
                      border: "1px solid red",
                      color: "red",
                    }}
                  >
                    Delete Question
                  </button>
                </div>
              ) : (
                <div style={{ color: "red", margin: "2%" }}>
                  Bu Soru Silinmiştir
                </div>
              )}
              <div style={{ display: "flex", borderBottom: 1 }}>
                <p style={styles.id}>User Id</p>
                <p style={styles.desc1}>Description 1</p>
                <p style={styles.desc1}>Description2</p>
              </div>
              <Divider />
              <div style={{ scrollBehavior: "smooth" }}>
                {details.map((item) => (
                  <React.Fragment key={item.UserId}>
                    <div style={{ display: "flex", padding: "6px 0" }}>
                      <p style={styles.id}>{item.UserId}</p>
                      <p style={styles.desc1}>{item.Description1}</p>
                      <p style={styles.desc1}>{item.Description2}</p>
                    </div>
                    <Divider />
                  </React.Fragment>
                ))}
              </div>
            </>
          )}
        </DialogContent>
      </div>
    </Dialog>
  );
}
const styles = {
  generalContainer: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
  },
  container: {
    display: "flex",
  },
  id: {
    width: 60,
    padding: 0,
    margin: 0,
    marginTop: 4,
  },
  desc1: {
    flex: 1,
    padding: 0,
    margin: 0,
    marginTop: 4,
  },
  AnswerOpt: {
    width: 20,
    padding: 1,
    backgroundColor: Primary.TopBar,
    color: Primary.Background,
    margin: 10,
  },
  deleteModalStyle: {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    margin: "20px",
    color: "red",
  },
  deletebuttonStyle: {
    display: "flex",
    justifyContent: "center",
    gap: "10px",
    margin: "10px",
  },
  deleteConfirm: {
    minWidth: "100px",
    minHeight: "30px",
    color: "red",
    border: "3px solid red",
  },
  deleteConfirmClose: {
    minWidth: "100px",
    minHeight: "30px",
    color: "green",
    border: "3px solid green",
  },
  videoTabBar: {
    display: "flex",
    gap: 4,
    padding: "8px 8px 0 8px",
  },
  videoTab: {
    padding: "6px 16px",
    border: "none",
    borderBottom: "2px solid transparent",
    background: "transparent",
    cursor: "pointer",
    fontSize: 14,
    color: "#5f6368",
  },
  videoTabActive: {
    padding: "6px 16px",
    border: "none",
    borderBottom: "2px solid #4285f4",
    background: "transparent",
    cursor: "pointer",
    fontSize: 14,
    fontWeight: 600,
    color: "#4285f4",
  },
  videoTabDisabled: {
    padding: "6px 16px",
    border: "none",
    borderBottom: "2px solid transparent",
    background: "transparent",
    cursor: "not-allowed",
    fontSize: 14,
    color: "#bdbdbd",
  },
};
export default ReportDialog;
